"use client";
import { MinusIcon, PlusIcon } from "lucide-react";
import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@app/_context";
import type { ChangeEvent, ComponentProps } from "react";

import { isAdyenCheckoutEnabled } from "@/config/checkout";

import { useCheckoutContext } from "../Checkout.hooks";
import { checkoutStore } from "../Checkout.store";

type ToggleDeliveryAddressProps = ComponentProps<"div">;

export default function CheckoutToggleDeliveryAddress(
  props: ToggleDeliveryAddressProps,
) {
  const t = useTranslate();
  useCheckoutContext();
  const marketConfig = useMarket().state.market;
  const hasSeparateDeliveryAddress = checkoutStore(
    (state) => state.hasSeparateDeliveryAddress,
  );
  const setHasSeparateDeliveryAddress = checkoutStore(
    (state) => state.setHasSeparateDeliveryAddress,
  );
  const setDeliveryOption = checkoutStore((state) => state.setDeliveryOption);

  function handleSeparateDeliveryAddressChange(
    event: ChangeEvent<HTMLInputElement>,
  ) {
    // Update the checkout store when toggling delivery address checkbox
    setHasSeparateDeliveryAddress(event.target.checked);
    setDeliveryOption();
  }

  if (isAdyenCheckoutEnabled({ marketConfig }) === false) {
    return null;
  }

  return (
    <div {...props}>
      <input
        id="hasSeparateDeliveryAddress"
        name="hasSeparateDeliveryAddress"
        type="checkbox"
        className="sr-only"
        onChange={handleSeparateDeliveryAddressChange}
        checked={hasSeparateDeliveryAddress}
      />
      <label
        htmlFor="hasSeparateDeliveryAddress"
        className="inline-flex cursor-pointer items-center gap-2 py-2 select-none"
      >
        {hasSeparateDeliveryAddress ? (
          <MinusIcon strokeWidth={1} className="size-3" />
        ) : (
          <PlusIcon strokeWidth={1} className="size-3" />
        )}
        {t("toggleDeliveryAddressLabel")}
      </label>
    </div>
  );
}
